import { createToastInterface } from "vue-toastification";

export default function (ctx, inject) {
  const toast = createToastInterface({"cssFile":"\u002Fusr\u002Fsrc\u002Fnuxt-app\u002Fnode_modules\u002Fvue-toastification\u002Fdist\u002Findex.css","position":"top-center","toastDefaults":{"error":{"timeout":10000}}});
  inject('toast', toast);
}
